import { render } from "./Evidencia-Component.vue?vue&type=template&id=0ae9330c"
import script from "./Evidencia-Component.vue?vue&type=script&lang=js"
export * from "./Evidencia-Component.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__